import { render, staticRenderFns } from "./UserGroupsNew.vue?vue&type=template&id=1aacf4a3&"
import script from "./UserGroupsNew.vue?vue&type=script&lang=js&"
export * from "./UserGroupsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports